import { Skeleton } from '@mui/material';

const LoadingState = () =>
  new Array(3).fill(0).map((_, idx) => (
    <Skeleton
      sx={{
        backgroundColor: (theme) => theme.palette.grey[800],
        borderRadius: 2,
        '&:not(:last-child)': {
          mb: 4,
        },
      }}
      key={idx}
      variant="rectangular"
      height={300}
    />
  ));

export default LoadingState;
